module.exports = __webpack_public_path__ + "img/recommendation-1.4ccf6842.svg";